import React from 'react'

const SecondBill = () => {
  return (
    <svg
      width="23"
      height="27"
      viewBox="0 0 23 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.98242 20.25C5.51644 20.25 5.13867 20.6277 5.13867 21.0938C5.13867 21.5598 5.51644 21.9375 5.98242 21.9375H9.35742C9.82342 21.9375 10.2012 21.5598 10.2012 21.0938C10.2012 20.6277 9.82342 20.25 9.35742 20.25H5.98242Z"
        fill="black"
      />
      <path
        d="M5.13867 16.875C5.13867 16.409 5.51644 16.0312 5.98242 16.0312H12.7324C13.1984 16.0312 13.5762 16.409 13.5762 16.875C13.5762 17.341 13.1984 17.7188 12.7324 17.7188H5.98242C5.51644 17.7188 5.13867 17.341 5.13867 16.875Z"
        fill="black"
      />
      <path
        d="M5.98242 11.8125C5.51644 11.8125 5.13867 12.1902 5.13867 12.6562C5.13867 13.1223 5.51644 13.5 5.98242 13.5H16.1074C16.5734 13.5 16.9512 13.1223 16.9512 12.6562C16.9512 12.1902 16.5734 11.8125 16.1074 11.8125H5.98242Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.0137 9.28792V9.28125C22.0137 9.26353 22.0132 9.24581 22.012 9.22818C22.0132 9.24801 22.0138 9.268 22.0137 9.28792L12.8454 0.00760027C12.8082 0.00256548 12.7705 0 12.7324 0H4.29492C1.96497 0 0.0761719 1.8888 0.0761719 4.21875V22.7812C0.0761719 25.1112 1.96497 27 4.29492 27H17.7949C20.1249 27 22.0137 25.1112 22.0137 22.7812V9.28792ZM11.8887 5.90625C11.8887 8.2362 13.7775 10.125 16.1074 10.125H20.3262V22.7812C20.3262 24.1793 19.1929 25.3125 17.7949 25.3125H4.29492C2.89695 25.3125 1.76367 24.1793 1.76367 22.7812V4.21875C1.76367 2.82078 2.89695 1.6875 4.29492 1.6875H11.8887V5.90625ZM13.5762 2.88074L19.1329 8.4375H16.1074C14.7094 8.4375 13.5762 7.30422 13.5762 5.90625V2.88074Z"
        fill="black"
      />
    </svg>
  )
}

export default SecondBill
